import { withStyles } from "@material-ui/core/styles";
import React from "react";
import Recaptcha from "react-recaptcha";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { bindActionCreators, Dispatch } from "redux";
import gql from "graphql-tag";
import ApolloClient from "apollo-client";
import { withApollo } from "react-apollo";
import {
  GetInfoUsuarrioTrocarSenhaDocument,
  GetInfoUsuarrioTrocarSenhaQuery,
  GetInfoUsuarrioTrocarSenhaQueryVariables,
  LoginProps,
  withLogin,
} from "../../graphql/components";
import { notAllowConciliador } from "../../redux/actions/allowAction";
import { authenticated } from "../../redux/actions/loginAction";
import "../../styles/custom/forms/LoginForm.css";
import Routes from "../../utils/routes";
import IsVisContext from "../CRUD/isVisContext";
import SnackMessage from "../SnakBar";
import styles from "./user-jss";
import LoginConcilia from "./LoginConcilia";
import LoginSPC from "../../containers/Pages/LoginSPC";
import configureStore from "../../redux/configureStore";
import { autenticarApi, autenticarApiPorTicket } from "../../services/authService";
import { MENSAGEM_CREDENCIAL_INVALIDA, mensagemErroLogin } from "./helpers/mensagemErroLogin";
import { MENSAGEM_LINK_EXPIRADO, linkTrocaSenhaValido } from "./helpers/linkTrocaSenha";
import { carregaChunk } from "../../utils/carregaChunk";
const EsqueciMinhaSenha = React.lazy(() => carregaChunk(() => import("./esqueciMinhaSenha")));
const RedefinirMinhaSenha = React.lazy(() => carregaChunk(() => import("./redefinirMinhaSenha")));

const LOGIN_POR_TICKET = gql`
  mutation loginPorTicket($ticket: String) {
    loginPorTicket(ticket: $ticket)
  }
`;

const GET_TICKET_HANDOFF = gql`
  query getTicketHandoff {
    getTicketHandoff
  }
`;

interface LoginFormProps extends RouteComponentProps {
  classes?: any;
  authenticate: typeof authenticated;
  notAllowConciliador: typeof notAllowConciliador;
  loginConcilia?: boolean;
  client: ApolloClient<any>;
}

interface StateLogin {
  showPassword: boolean;
  password: string;
  username: string;
  loading: boolean;
  valueRecaptcha: string | null;
  esqueciMinhaSenhaOpen: boolean;
  openSnackMessage: boolean;
  variantSnackMessage: "success" | "warning" | "info" | "error";
  snackMessage: string;
  renderRecaptcha: boolean;
  idTrocaSenha: string | null;
  isTest: boolean;
}

class LoginForm extends React.Component<LoginProps<LoginFormProps>, StateLogin> {
  static contextType = IsVisContext;

  recaptchaRef: React.RefObject<Recaptcha>;
  loginRef: any;
  timeout: NodeJS.Timeout;
  static defaultProps: { loginConcilia: boolean };
  constructor(props: LoginProps<LoginFormProps>) {
    super(props);
    this.state = {
      showPassword: false,
      password: "",
      username: "",
      loading: false,
      valueRecaptcha: "",
      esqueciMinhaSenhaOpen: false,
      openSnackMessage: false,
      variantSnackMessage: "success",
      snackMessage: "",
      renderRecaptcha: false,
      idTrocaSenha: null,
      isTest: false,
    };
    this.recaptchaRef = React.createRef();
    this.timeout = setInterval(() => {
      if (!this.state.loading && this.recaptchaRef.current) {
        this.recaptchaRef.current.reset();
        this.recaptchaRef.current.forceUpdate();
        this.recaptchaRef.current.execute();
        this.loginRef.focus();
      }
    }, 55000);
  }

  componentDidMount() {
    this.props.notAllowConciliador();
    //this.loginRef.focus();
    const ticket = this.useQuery().get("idsession");
    if (ticket) {
      this.executeLoginPorTicket(ticket);
    } else {
      const idTrocaSenha = this.useQuery().get("idTrocaSenha");
      if (idTrocaSenha) {
        this.abrirRedefinicaoSenha(idTrocaSenha);
      }
      if (process.env.REACT_APP_TEST === "false") {
        this.executeCaptcha();
      } else {
        this.setState({ isTest: true, valueRecaptcha: " " });
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.timeout);
  }

  change = (event: React.FormEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget;

    this.setState(({
      [name]: value.trim(),
    } as unknown) as Pick<StateLogin, keyof StateLogin>);
  };

  closeEsqueciMinhaSenha = () => this.setState({ esqueciMinhaSenhaOpen: false });

  closeRedefinirMinhaSenha = () => this.setState({ idTrocaSenha: null });

  abrirRedefinicaoSenha = async (idTrocaSenha: string) => {
    try {
      const resposta = await this.props.client.query<
        GetInfoUsuarrioTrocarSenhaQuery,
        GetInfoUsuarrioTrocarSenhaQueryVariables
      >({
        query: GetInfoUsuarrioTrocarSenhaDocument,
        variables: { param: idTrocaSenha },
        fetchPolicy: "no-cache",
      });
      if (linkTrocaSenhaValido(resposta.data && resposta.data.getInfoUsuarrioTrocarSenha)) {
        this.setState({ idTrocaSenha });
        return;
      }
    } catch (e) {
      console.log(e);
    }
    this.setMessage("warning", MENSAGEM_LINK_EXPIRADO);
  };

  openEsqueciMinhaSenha = () => this.setState({ esqueciMinhaSenhaOpen: true });

  useQuery = () => {
    return new URLSearchParams(this.props.location.search);
  };

  handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (this.state.valueRecaptcha) {
      this.executeLogin(this.state.username, this.state.password);
    } else if (!this.state.valueRecaptcha) {
      this.recaptchaRef.current!.reset();
      this.recaptchaRef.current!.execute();
    }
  };

  executeLogin = async (username: string, password: string) => {
    try {
      this.setState({ loading: true });
      const page = await this.props.mutate({
        variables: {
          password,
          username,
          values: { recaptcha: this.state.isTest ? "" : this.state.valueRecaptcha! },
        },
      });
      if (this.recaptchaRef.current) {
        this.recaptchaRef.current.reset();
        this.recaptchaRef.current.execute();
      }
      this.setState({ loading: false });
      if (page) {
        const toPage = page.data!.login!;
        if (toPage === "LOGGEDOUT") {
          this.setState({ loading: false });
          this.setMessage("error", MENSAGEM_CREDENCIAL_INVALIDA);
        } else if (toPage === "jsf") {
          await this.redirecionaParaJsf();
        } else {
          // Best-effort: o JWT alimenta as telas novas (ConciliadorApi). Falha aqui nao
          // pode barrar o login, cuja fonte de verdade continua sendo a mutation GraphQL.
          try {
            await autenticarApi(username, password);
          } catch (erroJwt) {
            console.warn("Nao foi possivel obter o token da API nova", erroJwt);
          }
          this.direcionaAposLogin(toPage);
        }
      }
    } catch (e) {
      this.setState({ loading: false });
      this.setMessage("error", mensagemErroLogin(e));
      if (this.recaptchaRef.current) {
        this.recaptchaRef.current.reset();
        this.recaptchaRef.current.execute();
      }
    }
  };

  executeLoginPorTicket = async (ticket: string) => {
    try {
      this.setState({ loading: true });
      const resposta = await this.props.client.mutate<{ loginPorTicket: string }>({
        mutation: LOGIN_POR_TICKET,
        variables: { ticket },
      });
      this.setState({ loading: false });

      const toPage = resposta && resposta.data ? resposta.data.loginPorTicket : null;
      if (!toPage || toPage === "LOGGEDOUT") {
        this.setMessage("error", MENSAGEM_CREDENCIAL_INVALIDA);
        return;
      }
      if (toPage === "jsf") {
        await this.redirecionaParaJsf();
        return;
      }
      await this.obtemJwtPorHandoff();
      this.direcionaAposLogin(toPage);
    } catch (e) {
      this.setState({ loading: false });
      this.setMessage("error", MENSAGEM_CREDENCIAL_INVALIDA);
    }
  };

  // O ticket e de uso unico: o consumido pelo loginPorTicket nao serve para a API, por
  // isso pede-se um segundo, ja com a sessao do JSF criada
  obtemJwtPorHandoff = async () => {
    try {
      const resposta = await this.props.client.query<{ getTicketHandoff: string }>({
        query: GET_TICKET_HANDOFF,
        fetchPolicy: "no-cache",
      });
      const ticket = resposta && resposta.data ? resposta.data.getTicketHandoff : null;
      if (ticket) {
        await autenticarApiPorTicket(ticket);
      }
    } catch (erroJwt) {
      console.warn("Nao foi possivel obter o token da API nova pelo handoff", erroJwt);
    }
  };

  redirecionaParaJsf = async () => {
    const resposta = await this.props.client.query<{ getTicketHandoff: string }>({
      query: GET_TICKET_HANDOFF,
      fetchPolicy: "no-cache",
    });
    const ticket = resposta && resposta.data ? resposta.data.getTicketHandoff : null;
    if (!ticket) {
      this.setMessage("error", MENSAGEM_CREDENCIAL_INVALIDA);
      return;
    }
    await configureStore().persistor.flush();
    await configureStore().persistor.purge();
    window.location.href = "/Conciliador/login/loginPass.jsf?ticket=" + encodeURIComponent(ticket);
  };

  direcionaAposLogin = (toPage: string) => {
    this.props.authenticate(toPage);
    const isVis = this.useQuery().get("isVis");
    if (isVis && isVis === "true") {
      this.context.changeIsVis("vis");
      this.props.history.push(Routes.painel.route);
    } else if (this.props.location.pathname.indexOf("spc") !== -1) {
      this.context.changeIsVis("spc");
      this.props.history.push(Routes.home.route);
    } else {
      this.props.history.push(Routes.home.route);
    }
  };

  handleClickShowPassword = () => {
    const { showPassword } = this.state;
    this.setState({ showPassword: !showPassword });
  };

  handleMouseDownPassword = (event: any) => {
    event.preventDefault();
  };

  verifyCallback = (value: string) => {
    this.setState({ valueRecaptcha: value }, () => {
      this.loginRef.focus();
    });
  };

  executeCaptcha = () => {
    setTimeout(() => {
      this.setState({ renderRecaptcha: true }, () => this.recaptchaRef.current!.execute());
    }, 300);
    this.loginRef.focus();
  };

  closeSnackMessage = () => this.setState({ openSnackMessage: false });

  setLoginRef = (ref: any) => (this.loginRef = ref);

  setMessage = (variantSnackMessage: "success" | "warning" | "info" | "error", snackMessage: string) =>
    this.setState({ variantSnackMessage, snackMessage, openSnackMessage: true });

  log = (msg: string) => () => {
    console.log(msg);
  };

  render() {
    const { classes } = this.props;
    return (
      <>
        {this.props.loginConcilia ? (
          <LoginConcilia
            showPassword={this.state.showPassword}
            valueRecaptcha={this.state.valueRecaptcha}
            handleSubmit={this.handleSubmit}
            loading={this.state.loading}
            openEsqueciMinhaSenha={this.openEsqueciMinhaSenha}
            change={this.change}
            classes={classes}
            handleClickShowPassword={this.handleClickShowPassword}
            handleMouseDownPassword={this.handleMouseDownPassword}
            setLoginRef={this.setLoginRef}
          />
        ) : (
          <LoginSPC
            valueRecaptcha={this.state.valueRecaptcha}
            handleSubmit={this.handleSubmit}
            openEsqueciMinhaSenha={this.openEsqueciMinhaSenha}
            change={this.change}
            setLoginRef={this.setLoginRef}
          />
        )}
        {this.state.renderRecaptcha && (
          <Recaptcha
            hl="pt-BR"
            ref={this.recaptchaRef}
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6Lf9xU8UAAAAAIUovl8DXe-aQQZjlOSLs3B4Wv-u"}
            render="onload"
            size="invisible"
            verifyCallback={this.verifyCallback}
            onloadCallback={this.log("capthca loaded")}
            expiredCallback={this.log("captcha expiredCallback")}
          />
        )}
        <React.Suspense fallback={null}>
          <EsqueciMinhaSenha
            setMessage={this.setMessage}
            isOpen={this.state.esqueciMinhaSenhaOpen}
            handleClose={this.closeEsqueciMinhaSenha}
          />
          <RedefinirMinhaSenha
            setMessage={this.setMessage}
            isOpen={this.state.idTrocaSenha != null}
            handleClose={this.closeRedefinirMinhaSenha}
            idTrocaSenha={this.state.idTrocaSenha}
          />
          <SnackMessage
            close={this.closeSnackMessage}
            open={this.state.openSnackMessage}
            variant={this.state.variantSnackMessage}
            message={this.state.snackMessage}
          />
        </React.Suspense>
      </>
    );
  }
}

LoginForm.defaultProps = {
  loginConcilia: true,
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  authenticate: bindActionCreators(authenticated, dispatch),
  notAllowConciliador: bindActionCreators(notAllowConciliador, dispatch),
});

const LoginFormConnected = connect(
  null,
  mapDispatchToProps
)(LoginForm);

const withLoginMutation = withLogin<LoginFormProps>({});

// @ts-ignore
export default withStyles(styles as any)(withLoginMutation(withApollo(withRouter(LoginFormConnected) as any))) as React.ComponentType<{ loginConcilia?: boolean }>;
